import { render, staticRenderFns } from "./FaPiao.vue?vue&type=template&id=5e753cc9&scoped=true&"
import script from "./FaPiao.vue?vue&type=script&lang=js&"
export * from "./FaPiao.vue?vue&type=script&lang=js&"
import style0 from "./FaPiao.vue?vue&type=style&index=0&id=5e753cc9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e753cc9",
  null
  
)

export default component.exports